import {
	FAILED_SCORE,
	ScoreCategory,
	type ScoreSeriesEntry,
	type TreamsCategoryScore,
	type TreamsScore,
	type TreamsScoreRow,
	isFailedScore,
} from '@treams/treams-analytics/src/score/models/ScoreTypes';

export { FAILED_SCORE, ScoreCategory, isFailedScore };
export type { ScoreSeriesEntry, TreamsCategoryScore, TreamsScore, TreamsScoreRow };

export enum MomentStatus {
	Completed = 'COMPLETED',
	Open = 'OPEN',
	Skipped = 'SKIPPED',
}

export enum MomentTemplateType {
	Evaluation = 'EVALUATION',
	Feedback = 'FEEDBACK',
	Goals = 'GOALS',
	Message = 'MESSAGE',
	TalentReview = 'TALENT_REVIEW',
}

export enum FeedbackStatus {
	Shared = 'SHARED',
	Draft = 'DRAFT',
	Cancelled = 'CANCELLED',
}

export enum EvaluationStatus {
	Signed = 'SIGNED',
	Shared = 'SHARED',
	Draft = 'DRAFT',
}

export interface Snapshot {
	goals: {
		ownerID: string;
		ownerType: string;
		completedAt?: Date | null;
		archivedAt?: Date | null;
	}[];
	moments: {
		userID: string;
		momentTemplateID: string;
		status?: MomentStatus;
		archivedAt?: Date | null;
	}[];
	templates: {
		momentTemplateID: string;
		type?: MomentTemplateType;
	}[];
	feedback: {
		userID?: string | null; // ontvanger/onderwerp
		requesterID: string;
		status?: FeedbackStatus;
		isArchived?: boolean;
		archivedAt?: Date | null;
	}[];
	submissions: {
		employeeID: string;
		employeeStatus?: EvaluationStatus;
		managerStatus?: EvaluationStatus;
		archivedAt?: Date | null;
	}[];
}

export type UseTreamsScore = {
	isLoading: boolean;
	rows: TreamsScoreRow[];
	scores: TreamsScore;
	// Rolling score for every group at each requested history end-date; empty
	// when no history was requested.
	series: ScoreSeriesEntry[];
	// A qualifying engagement survey ran inside the scoring window; drives the
	// engagement module state instead of the current feature toggle.
	engagementSurveyAvailable: boolean;
};

export type ScoreColors = { background: string; color: string };

export enum ScoreModuleState {
	Enabled = 'ENABLED', // in plan and switched on -> real score
	Unavailable = 'UNAVAILABLE', // not in plan -> grey box + dash
	Disabled = 'DISABLED', // in plan but switched off -> score 1, red box
}

export type ScoreModuleStatus = Record<ScoreCategory, ScoreModuleState>;
